import { AmountSuperScript } from "components/design/AmountSuperScript";

type TotalDueTodayProps = {
  total?: number;
  totalDueToday?: number;
};

export const TotalDueToday = ({ total, totalDueToday }: TotalDueTodayProps) => {
  if (total === undefined || totalDueToday === total) {
    return null;
  }

  const dueToday = totalDueToday ?? 0;
  const remainingAmount = total - dueToday;

  return (
    <div className="t-flex t-flex-col t-bg-surface-purple t-border t-border-solid t-border-purple-10 t-rounded t-p-4 t-gap-y-2.5">
      <div className="t-flex t-justify-between t-items-center t-text-subtext">
        Total due today
        <span className="t-text-subtext">
          <AmountSuperScript amount={dueToday} />
        </span>
      </div>
      <span className="t-text-body-sm-lite t-text-text-30">
        This is the amount you’ll be charged today. The remaining $
        {remainingAmount} will be billed later as part of your regular billing
        cycle.
      </span>
    </div>
  );
};
